export const getDocumentStatusOptions = (t: any) => [
  { value: "Draft", label: t("Draft", {}, "statuses") },
  { value: "Preliminary_x0020_approval", label: t("Preliminary_x0020_approval", {}, "statuses") },
  { value: "Approved", label: t("Approved", {}, "statuses") },
  { value: "Rejected", label: t("Rejected", {}, "statuses") },
  { value: "Archived", label: t("Archived", {}, "statuses") },
  { value: "Posted", label: t("Posted", {}, "statuses") },
  { value: "To_x0020_be_x0020_completed", label: t("To_x0020_be_x0020_completed", {}, "statuses") },
];

export const getPaymentStatusOptions = (t: any) => [
  { value: "__EMPTY__", label: t("__EMPTY__", {}, "payments") },
  { value: "Generated_x0020_Payment", label: t("Generated_x0020_Payment", {}, "payments") },
  { value: "Partially_x0020_Paid", label: t("Partially_x0020_Paid", {}, "payments") },
  { value: "Paid", label: t("Paid", {}, "payments") },
];